import * as api from '../../services/qaForm'

export const FETCH_FORMS= 'FETCH_FORMS';



export const fetchExtendForms = (id) => ({
    type: FETCH_FORMS,
    payload: {
        promise: api.findExtendForms({eventId: id})
    }
});




// WEBPACK FOOTER //
// ./src/redux/actions/form.js